<template>
  <div class="container">

    <div class="topBox">
      <h1>套餐管理</h1>
      <el-button type="primary" @click="onClickAddNewData()">添加套餐</el-button>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="imageList" label="图片" width="150">
        <template #default="{ row }">
          <div class="imgBox">
            <img v-if="row.imageList && row.imageList.length > 0" :src="row.imageList[0].url" alt="图片" />
            <span v-if="row.imageList">*{{ row.imageList.length }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="namezh" label="标题" width="300" />
      <el-table-column prop="price" label="价格" width="100">
        <template #default="{ row }">
          ¥{{ row.price }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间" width="200" />

      <el-table-column fixed="right" label="操作" min-width="120">
        <template #default="{ row }">
          <el-button link type="primary" size="small" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button link type="danger" size="small" @click="handleShowDeleteDialog(row)">
            删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>



    <el-dialog v-model="dialogFormVisible" title="编辑套餐" width="800">
      <el-form :model="currentCarData" ref="ruleFormRef" :rules="rules">

        <el-row>
          <el-col :span="24">
            <el-form-item label="相关图片" prop="WeddingImages">
              <div class="avatar-container">
                <div class="avatar-box" v-for="(item, index) in imageArray" :key="item.id">
                  <el-image class="avatar" :src="item.url" fit="cover" />

                  <Delete class="delete-icon" style="width: 1em; height: 1em;" @click="removeImage1(index)" />

                </div>

                <el-upload v-if="imageArray.length < 7" ref="upload" class="upload-demo" :limit="1"
                  :before-upload="beforeUpload" :show-file-list="false">

                  <div class="avatar-box">
                    <FolderAdd class="uploader-icon" style="width: 1em; height: 1em;" />
                  </div>

                </el-upload>


              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="维语套餐名称" prop="name">
              <el-input v-model="currentCarData.name" autocomplete="off" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中文套餐名称" prop="nameZh">
              <el-input v-model="currentCarData.nameZh" autocomplete="off" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item label="套餐价格" prop="price">
              <el-input v-model="currentCarData.price" type="number" min="0" maxlength="10" required></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="摄影师" prop="teamPhotoGrap">
              <el-select v-model="currentCarData.teamPhotoGrap" placeholder="请选择摄影师资历"
                @change="handleDialogSelectionChange1">
                <el-option v-for="item in categoriesPhotoGrap" :key="item.id" :label="item.labelZh" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="8">
            <el-form-item label="化妆师" prop="teamMakeup">
              <el-select v-model="currentCarData.teamMakeup" placeholder="请选择化妆师资历"
                @change="handleDialogSelectionChange2">
                <el-option v-for="item in categoriesMakeup" :key="item.id" :label="item.labelZh" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="灯光师" prop="lightingEngineer">
              <el-select v-model="currentCarData.lightingEngineer" placeholder="请选择">
                <el-option label="有" value="1"></el-option>
                <el-option label="无" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="化妆师助理" prop="makeupAssistant">
              <el-select v-model="currentCarData.makeupAssistant" placeholder="请选择">
                <el-option label="有" value="1"></el-option>
                <el-option label="无" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="微电影拍摄" prop="microFilm">
              <el-select v-model="currentCarData.microFilm" placeholder="请选择">
                <el-option label="有" value="1"></el-option>
                <el-option label="无" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="新娘服装套数" prop="omenClothing">
              <el-select v-model="currentCarData.omenClothing" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="新郎服装套数" prop="menClothing">
              <el-select v-model="currentCarData.menClothing" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="维语服装说明" prop="clothingDescription">
              <el-input type="textarea" v-model="currentCarData.clothingDescription" :rows="4"
              @change="handleClothingDescriptionChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="中文服装说明" prop="clothingDescriptionZh">
              <el-input type="textarea" v-model="currentCarData.clothingDescriptionZh" :rows="4"
              @change="handleClothingDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="维语造型说明" prop="mouldingDescription">
              <el-input type="textarea" v-model="currentCarData.mouldingDescription" :rows="4"
              @change="handleMouldingDescriptionChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="中文造型说明" prop="mouldingDescriptionZh">
              <el-input type="textarea" v-model="currentCarData.mouldingDescriptionZh" :rows="4"
              @change="handleMouldingDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">

          <el-col :span="12">
            <el-form-item label="场景" prop="mapChoice">
              <el-radio-group v-model="currentCarData.mapChoice">
                <el-radio :label="1">纯内景</el-radio>
                <el-radio :label="2">纯外景</el-radio>
                <el-radio :label="3">内外景</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="内景数量" prop="insideSceneNum">
              <el-select v-model="currentCarData.insideSceneNum" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="外景数量" prop="outsideSceneNum">
              <el-select v-model="currentCarData.outsideSceneNum" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="维语内景说明" prop="insideDescription">
              <el-input type="textarea" v-model="currentCarData.insideDescription" :rows="4"
              @change="handleInsideDescriptionChange"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="中文内景说明" prop="insideDescriptionZh">
              <el-input type="textarea" v-model="currentCarData.insideDescriptionZh" :rows="4"
              @change="handleInsideDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">

          <el-col :span="24">
            <el-form-item label="维语外景说明" prop="outsideDescription">
              <el-input type="textarea" v-model="currentCarData.outsideDescription" :rows="4"
              @change="handleOutsideDescriptionChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">

          <el-col :span="24">
            <el-form-item label="中文外景说明" prop="outsideDescriptionZh">
              <el-input type="textarea" v-model="currentCarData.outsideDescriptionZh" :rows="4"
              @change="handleOutsideDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="拍摄天数" prop="shootingDay">
              <el-select v-model="currentCarData.shootingDay" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="拍摄张数" prop="photoNum">
              <el-select v-model="currentCarData.photoNum" placeholder="请选择">
                <el-option v-for="num in 200" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="精修张数" prop="updatePhotoNum">
              <el-select v-model="currentCarData.updatePhotoNum" placeholder="请选择">
                <el-option v-for="num in 100" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="入册张数" prop="choicePhotoNum">
              <el-select v-model="currentCarData.choicePhotoNum" placeholder="请选择">
                <el-option v-for="num in 100" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="相册数量" prop="albumNum">
              <el-select v-model="currentCarData.albumNum" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="相框数量" prop="frameNum">
              <el-select v-model="currentCarData.frameNum" placeholder="请选择">
                <el-option v-for="num in 10" :key="num" :label="num" :value="num"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="维语相册说明" prop="albumDescription">
              <el-input type="textarea" v-model="currentCarData.albumDescription" :rows="4"
              @change="handleAlbumDescriptionChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="中文相册说明" prop="albumDescriptionZh">
              <el-input type="textarea" v-model="currentCarData.albumDescriptionZh" :rows="4"
              @change="handleAlbumDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="维语相框说明" prop="frameDescription">
              <el-input type="textarea" v-model="currentCarData.frameDescription" :rows="4"
              @change="handleFrameDescriptionChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="中文相框说明" prop="frameDescriptionZh">
              <el-input type="textarea" v-model="currentCarData.frameDescriptionZh" :rows="4"
              @change="handleFrameDescriptionZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="维语赠送" prop="pack">
              <el-input type="textarea" v-model="currentCarData.pack" placeholder="如果没有可不填" :rows="4"
              @change="handlePackChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="中文赠送" prop="packZh">
              <el-input type="textarea" v-model="currentCarData.packZh" placeholder="如果没有可不填" :rows="4"
              @change="handlePackZhChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="dialog-el" :span="24">
            <el-form-item label="套餐亮点" prop="commodity">
              <el-checkbox-group v-model="checkList1">
                <el-checkbox v-for="item in categoriesGoods" :key="item.id" :value="item.id" :disabled="item.disabled">
                  {{ item.labelZh }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>


        </el-row>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="success" @click="dialogMuBan = true">查看实例模板</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onClickAddData(ruleFormRef)">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogVisible" title="提示" width="300" :before-close="handleClose">
      <span>删除后无法恢复，确定要删除么？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelete()">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog v-model="dialogMuBan" title="乐队套餐模板" width="600">

      <el-row :gutter="20">
        <el-col :span="12">
          <h4>参考模板</h4>

          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">

            <el-carousel height="300px">
              <el-carousel-item>
                <el-image style="width: 100%; height: 300px"
                  src="https://p0.meituan.net/imgupload/be46b08efbb9b094170d319d00bd2b493403819.jpg%40watermark%3D0"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 300px"
                  src="https://qcloud.dpfile.com/pc/we4E_14bAcpV6KtFJDFPczRtqwqiOeioZXsvlGuGqst0dyciPvbAlEFZ_qaWpz84.jpg"
                  fit="cover" />
              </el-carousel-item>
              <el-carousel-item>
                <el-image style="width: 100%; height: 300px"
                  src="https://qcloud.dpfile.com/pc/-hkZQAR3n0iZ8IQg12SN2e5FgWu6GGwafyEJDrazT_am5NcBN5EReyCyqNpXiSOc.jpg"
                  fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block;">雪莲山高尔夫庄园草坪婚纱照</span>
            <span style="font-size: 14px;color: black;margin: 10px 10px; color:red; text-align: left; 
        display: block;">
              ￥5688
            </span>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">团队</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">摄影师</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">总监</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">化妆师</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">高级化妆师</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">灯光师</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">有</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">化妆师助理</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">有</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄微电影</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">无</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">造型</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">新娘服装</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">4套</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">新郎服装</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">4套</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">服装说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1; text-align:left; ">提供新人服装男女各四套，婚纱礼服全场任选，不分区域</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">造型说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1; text-align:left;">首席化妆师一对一服务，提供精致妆面造型四组</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">场景</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄场景</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">内外景结合</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">内景数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">2个</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">外景数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">2个</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">内景说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">双内景拍摄：
                全新升级金座内景 + 维多利亚教堂</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">外景说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">高尔夫球场外景--莫奈庄园</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">拍摄</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄天数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">1天</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄张数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">140张</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">精修张数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">35张</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">入册张数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">35张</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">成品</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">相册数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">2本</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">相框数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">4个</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">相册说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">18寸高端定制相册一本（款式任选）
                12寸高端定制相册一本 (款式任选)</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">相框说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">艺术四件套照片墙一组</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">补充说明</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">套餐亮点</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                不满意重拍 底片全送 全程无隐形消费 极速出精修 七天选片 全程一对一服务
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">套餐礼包</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                赠送结婚登记照拍摄一组 赠送酒店迎宾海报一张 赠送10寸摆台两个
              </span>
            </div>

          </div>

        </el-col>
        <el-col :span="12">
          <h4>您编辑的</h4>
          <div style="border: 2px solid grey; border-radius: 8px;height: 600px;overflow-y: auto;">
            <el-carousel height="300px">
              <el-carousel-item v-for="(image, index) in currentCarData.imageList" :key="index">
                <el-image style="width: 100%; height: 300px" :src="image.url" fit="cover" />
              </el-carousel-item>
            </el-carousel>

            <span style="font-size: 14px;color: black;margin: 10px 10px; text-align: left; 
        display: block;">{{ currentCarData.nameZh }}</span>
            <span style="font-size: 14px;color: black;margin: 10px 10px; color:red; text-align: left; 
        display: block;">
              ￥{{ currentCarData.price }}
            </span>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">团队</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">摄影师</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black;">{{ diaologTeamPhotoGrapType.labelZh }}</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">化妆师</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{ diaologTeamMakeupType.labelZh }}</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">灯光师</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{ currentCarData.lightingEngineer == 1 ? '有' : '无' }}</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">化妆师助理</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{ currentCarData.makeupAssistant == 1 ? '有' : '无' }}</span>
            </div>
            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄微电影</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{ currentCarData.microFilm == 1 ? '有' : '无' }}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">造型</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">新娘服装</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.omenClothing}}套</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">新郎服装</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.menClothing}}套</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">服装说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1; text-align:left; ">{{currentCarData.clothingDescriptionZh}}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">造型说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1; text-align:left;">{{currentCarData.mouldingDescriptionZh}}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">场景</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄场景</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.mapChoice}}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">内景数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.insideSceneNum}}个</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">外景数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.outsideSceneNum}}个</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">内景说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                {{currentCarData.insideDescriptionZh}}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">外景说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">{{currentCarData.outsideDescriptionZh}}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">拍摄</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄天数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.shootingDay}}天</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">拍摄张数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.photoNum}}张</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">精修张数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.updatePhotoNum}}张</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">入册张数</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.choicePhotoNum}}张</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: center;">
              <div style=" background-color: #f5f5f5; 
           border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">成品</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">相册数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.albumNum}}本</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;">相框数量</span>
              <span style="font-size: 12px; margin-left: 10px; color: black;">{{currentCarData.frameNum}}个</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">相册说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                {{currentCarData.albumDescriptionZh}}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">相框说明</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">{{currentCarData.frameDescriptionZh}}</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <div style=" background-color: #f5f5f5; border-radius: 4px;width: 4px;height: 15px;background-color: red;"></div>
              <span style="font-size: 14px;font-weight: bold; margin-left: 5px;">补充说明</span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">套餐亮点</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                {{currentCarData.goods}}
              </span>
            </div>

            <div style="display: flex;margin: 10px 10px;align-items: start;">
              <span style="font-size: 12px;  flex-shrink: 0; ">套餐礼包</span>
              <span
                style="font-size: 12px; margin-left: 10px; color: black; word-break: break-word; flex: 1;text-align:left;">
                {{currentCarData.packZh}}
              </span>
            </div>

          </div>

        </el-col>
      </el-row>

    </el-dialog>

  </div>
</template>

<script>
import { ref, computed, onMounted, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { get, upload, post } from '@/api/http';
import { useStore } from 'vuex';


export default {
  name: 'PhotosPage',
  setup() {
    const store = useStore();

    const tableData = ref([]);
    const categoriesPhotoGrap = ref([]);
    const categoriesMakeup = ref([]);
    const categoriesGoods = ref([]);
    const currentCarData = ref(null);
    const dialogFormVisible = ref(false);
    const imageArray = ref([]);
    const checkList1 = ref([]);
    const ruleFormRef = ref(null)

    const diaologTeamPhotoGrapType = ref({});
    const diaologTeamMakeupType = ref({});

    const dialogVisible = ref(false);

    const dialogMuBan = ref(false);



    const shopId = computed(() => {
      const shop = store.state.shop;
      return shop ? shop.id : '';
    });

    // 表单验证规则
    const rules = reactive({
      WeddingImages: [
        {
          validator: (rule, value, callback) => {

            if (imageArray.value.length <= 0) {
              callback(new Error('请选择图片'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],
      name: [{ required: true, message: '请输入', trigger: 'blur' }],
      nameZh: [{ required: true, message: '请输入', trigger: 'blur' }],
      price: [
        { required: true, message: '请输入', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (value < 0) {
              callback(new Error('价格不能为负数'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }
      ],
      teamPhotoGrap: [{ required: true, message: '请选择摄影师资历', trigger: 'change' }],
      teamMakeup: [{ required: true, message: '请选择化妆师资历', trigger: 'change' }],
      lightingEngineer: [{ required: true, message: '请选择有无灯光师', trigger: 'change' }],
      makeupAssistant: [{ required: true, message: '请选择有无化妆师助理', trigger: 'change' }],
      microFilm: [{ required: true, message: '请选择有无微电影拍摄', trigger: 'change' }],
      omenClothing: [{ required: true, message: '请选择新娘服装数量', trigger: 'change' }],
      menClothing: [{ required: true, message: '请选择新郎服装数量', trigger: 'change' }],
      clothingDescription: [{ required: true, message: '请输入维语服装说明', trigger: 'blur' }],
      clothingDescriptionZh: [{ required: true, message: '请输入中文服装说明', trigger: 'blur' }],
      mouldingDescription: [{ required: true, message: '请输入维语造型说明', trigger: 'blur' }],
      mouldingDescriptionZh: [{ required: true, message: '请输入中文造型说明', trigger: 'blur' }],
      mapChoice: [{ required: true, message: '请选择场景', trigger: 'change' }],
      insideSceneNum: [{ required: true, message: '请选择内景数量', trigger: 'change' }],
      outsideSceneNum: [{ required: true, message: '请选择外景数量', trigger: 'change' }],
      insideDescription: [{ required: true, message: '请输入维语内景说明', trigger: 'blur' }],
      insideDescriptionZh: [{ required: true, message: '请输入中文内景说明', trigger: 'blur' }],
      outsideDescription: [{ required: true, message: '请输维语外景型说明', trigger: 'blur' }],
      outsideDescriptionZh: [{ required: true, message: '请输中文外景型说明', trigger: 'blur' }],
      shootingDay: [{ required: true, message: '请选择拍摄天数', trigger: 'change' }],
      photoNum: [{ required: true, message: '请选择拍摄张数', trigger: 'change' }],
      updatePhotoNum: [{ required: true, message: '请选择精修张数', trigger: 'change' }],
      choicePhotoNum: [{ required: true, message: '请选择入册张数', trigger: 'change' }],
      albumNum: [{ required: true, message: '请选择相册数量', trigger: 'change' }],
      albumDescription: [{ required: true, message: '请输入维语相册说明', trigger: 'blur' }],
      albumDescriptionZh: [{ required: true, message: '请输入中文相册说明', trigger: 'blur' }],
      frameNum: [{ required: true, message: '请选择相框数量', trigger: 'change' }],
      frameDescription: [{ required: true, message: '请输入维语相框说明', trigger: 'blur' }],
      frameDescriptionZh: [{ required: true, message: '请输入中文相框说明', trigger: 'blur' }],
      shopId: [{ required: true, message: '请输入店铺ID', trigger: 'blur' }],
      shopName: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
      commodity: [
        {
          validator: (rule, value, callback) => {

            if (checkList1.value.length <= 0) {
              callback(new Error('请选择'));
            } else {
              callback();
            }

          },
          trigger: 'change'
        }
      ],

    });


    onMounted(() => {
      getCategoryData();
      getData();
    });

    const getCategoryData = async () => {
      try {
        const response = await get('adminCategories/getCategoriesByParentId/23')
        if (response.code === 200) {

          var obj1 = response.data.find(item => item.id === 56);
          categoriesPhotoGrap.value = obj1.children;

          var obj2 = response.data.find(item => item.id === 57);
          categoriesMakeup.value = obj2.children;

          var obj3 = response.data.find(item => item.id === 64);
          categoriesGoods.value = obj3.children;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }


    const getData = async () => {
      try {
        const response = await get('adminWeddingPhotos/allShopPhotos', { "shopId": shopId.value })
        if (response.code === 200) {
          tableData.value = response.data;

        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }
    }

    const addData = async () => {

      var commodityGoods = checkList1.value.join(',');

      const dataParam = {
        'name': currentCarData.value.name,
        'nameZh': currentCarData.value.nameZh,
        'price': currentCarData.value.price,
        'teamPhotoGrap': diaologTeamPhotoGrapType.value ? diaologTeamPhotoGrapType.value.id : '',
        'teamMakeup': diaologTeamMakeupType.value ? diaologTeamMakeupType.value.id : '',
        'lightingEngineer': currentCarData.value.lightingEngineer,
        'makeupAssistant': currentCarData.value.makeupAssistant,
        'microFilm': currentCarData.value.microFilm,
        'omenClothing': currentCarData.value.omenClothing,
        'menClothing': currentCarData.value.menClothing,
        'clothingDescription': currentCarData.value.clothingDescription,
        'clothingDescriptionZh': currentCarData.value.clothingDescriptionZh,
        'mouldingDescription': currentCarData.value.mouldingDescription,
        'mouldingDescriptionZh': currentCarData.value.mouldingDescriptionZh,
        'mapChoice': currentCarData.value.mapChoice,
        'insideSceneNum': currentCarData.value.insideSceneNum,
        'outsideSceneNum': currentCarData.value.outsideSceneNum,
        'insideDescription': currentCarData.value.insideDescription,
        'insideDescriptionZh': currentCarData.value.insideDescriptionZh,
        'outsideDescription': currentCarData.value.outsideDescription,
        'outsideDescriptionZh': currentCarData.value.outsideDescriptionZh,
        'shootingDay': currentCarData.value.shootingDay,
        'photoNum': currentCarData.value.photoNum,
        'updatePhotoNum': currentCarData.value.updatePhotoNum,
        'choicePhotoNum': currentCarData.value.choicePhotoNum,
        'albumNum': currentCarData.value.albumNum,
        'albumDescription': currentCarData.value.albumDescription,
        'albumDescriptionZh': currentCarData.value.albumDescriptionZh,
        'frameNum': currentCarData.value.frameNum,
        'frameDescription': currentCarData.value.frameDescription,
        'frameDescriptionZh': currentCarData.value.frameDescriptionZh,
        'pack': currentCarData.value.pack,
        'packZh': currentCarData.value.packZh,
        'imagesId': currentCarData.value.imagesId,
        'commodityGoods': commodityGoods,
        'shopId': shopId.value,
        'status': currentCarData.value.status,
      };

      if (currentCarData.value.id) {
        dataParam.id = currentCarData.value.id;
      }


      try {
        const response = await post('adminWeddingPhotos/addPhotos', dataParam)
        if (response.code === 200) {
          dialogFormVisible.value = false;
          ElMessage.success("保存成功");
          getData();
        } else {
          ElMessage.error(response.msg)
        }
      } catch (error) {
        console.error('请求失败', error)
        ElMessage.error('请求失败，请重试')
      }


    }



    const uploadFile = async (file) => {
      await upload('adminUpload/image', file, { 'type': 21 })
        .then(response => {

          if (response.code == 200) {
            imageArray.value.push(response.data);
            currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');
          } else {
            ElMessage.error('上传失败，请重试')
          }

        })
        .catch(error => {
          console.error('请求失败', error)
          ElMessage.error('请求失败，请重试')
        });
    }

    const deleteData = async (id) => {
      await get('adminResourse/deleteResourse/' + id)
        .then(() => {
          ElMessage.success("删除成功");
        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const beforeUpload = (file) => {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'
      const isLt200KB = file.size / 1024 <= 200;

      if (!isImage) {
        ElMessage.error('请选择图片')
        return false;
      }

      if (!isLt200KB) {
        ElMessage.error('图片大小超过了200KB')
        return false;
      }

      uploadFile(file);
      return false; // 阻止默认上传行为
    }

    const deletePhotosData = async (id) => {
      await get('adminWeddingPhotos/deletePhotos/' + id)
        .then(() => {
          ElMessage.success("删除成功");
          dialogVisible.value = false;

        })
        .catch(error => {
          ElMessage.error(error);
        });
    }

    const handleEdit = (item) => {
      // 打印或处理编辑数据
      currentCarData.value = item;
      imageArray.value = item.imageList;


      if (item.commodityGoods != null) {
        checkList1.value = item.commodityGoods.split(',').map(Number);
      }

      const obj1 = categoriesPhotoGrap.value.find(obj => obj.id === item.teamPhotoGrap);
      diaologTeamPhotoGrapType.value = obj1;

      const obj2 = categoriesMakeup.value.find(obj => obj.id === item.teamMakeup);
      diaologTeamMakeupType.value = obj2;

      dialogFormVisible.value = true;
    };

    const onClickAddNewData = () => {

      currentCarData.value = {};
      imageArray.value = [];
      checkList1.value = [];
      diaologTeamPhotoGrapType.value = {};
      diaologTeamMakeupType.value = {};
      dialogFormVisible.value = true;


    }

    const onClickAddData = async (formEl) => {
      if (!formEl) return
      await formEl.validate((valid, fields) => {
        if (valid) {
          addData();
        } else {
          console.log('表单验证失败', fields)
          ElMessage.error('表单验证失败')
        }
      })
    }

    const removeImage1 = (index) => {
      if (imageArray.value[index] && imageArray.value[index].id) {
        deleteData(imageArray.value[index].id);
        imageArray.value.splice(index, 1);
        currentCarData.value.imagesId = imageArray.value.map(item => item.id).join(',');
      } else {
        console.error("该图片对象没有 id 属性！");
      }
    }


    const handleDialogSelectionChange1 = async (value) => {
      const obj = categoriesPhotoGrap.value.find(item => item.id === value);
      diaologTeamPhotoGrapType.value = obj;
    }
    const handleDialogSelectionChange2 = async (value) => {
      const obj = categoriesMakeup.value.find(item => item.id === value);
      diaologTeamMakeupType.value = obj;
    }


    const handleShowDeleteDialog = (row) => {
      currentCarData.value = row;
      dialogVisible.value = true;
    }

    const handleDelete = () => {
      deletePhotosData(currentCarData.value.id);
    }

    const handleClothingDescriptionChange = (val) => {
      currentCarData.value.clothingDescription = val.replace(/\r?\n/g, '\n')
    }

    const handleClothingDescriptionZhChange = (val) => {
      currentCarData.value.clothingDescriptionZh = val.replace(/\r?\n/g, '\n')
    }

    const handleMouldingDescriptionChange = (val) => {
      currentCarData.value.mouldingDescription = val.replace(/\r?\n/g, '\n')
    }

    const handleMouldingDescriptionZhChange = (val) => {
      currentCarData.value.mouldingDescriptionZh = val.replace(/\r?\n/g, '\n')
    }

    const handleInsideDescriptionChange = (val) => {
      currentCarData.value.insideDescription = val.replace(/\r?\n/g, '\n')
    }

    const handleInsideDescriptionZhChange = (val) => {
      currentCarData.value.insideDescriptionZh = val.replace(/\r?\n/g, '\n')
    }

    const handleOutsideDescriptionChange = (val) => {
      currentCarData.value.outsideDescription = val.replace(/\r?\n/g, '\n')
    }

    const handleOutsideDescriptionZhChange = (val) => {
      currentCarData.value.outsideDescriptionZh = val.replace(/\r?\n/g, '\n')
    }

    const handleAlbumDescriptionChange = (val) => {
      currentCarData.value.albumDescription = val.replace(/\r?\n/g, '\n')
    }

    const handleAlbumDescriptionZhChange = (val) => {
      currentCarData.value.albumDescriptionZh = val.replace(/\r?\n/g, '\n')
    }
    const handleFrameDescriptionChange = (val) => {
      currentCarData.value.frameDescription = val.replace(/\r?\n/g, '\n')
    }
    const handleFrameDescriptionZhChange = (val) => {
      currentCarData.value.frameDescriptionZh = val.replace(/\r?\n/g, '\n')
    }
    const handlePackChange = (val) => {
      currentCarData.value.pack = val.replace(/\r?\n/g, '\n')
    }
    const handlePackZhChange = (val) => {
      currentCarData.value.packZh = val.replace(/\r?\n/g, '\n')
    }
   

    

    return {
      tableData,
      categoriesPhotoGrap,
      categoriesMakeup,
      categoriesGoods,
      currentCarData,
      handleEdit,
      dialogFormVisible,
      imageArray,
      checkList1,
      diaologTeamPhotoGrapType,
      diaologTeamMakeupType,
      onClickAddData,
      onClickAddNewData,
      rules,
      ruleFormRef,
      removeImage1,
      handleDialogSelectionChange1,
      handleDialogSelectionChange2,
      beforeUpload,
      uploadFile,
      dialogVisible,
      handleShowDeleteDialog,
      handleDelete,
      dialogMuBan,
      handleClothingDescriptionChange,
      handleClothingDescriptionZhChange,
      handleMouldingDescriptionChange,
      handleMouldingDescriptionZhChange,
      handleInsideDescriptionChange,
      handleInsideDescriptionZhChange,
      handleOutsideDescriptionChange,
      handleOutsideDescriptionZhChange,
      handleAlbumDescriptionChange,
      handleAlbumDescriptionZhChange,
      handleFrameDescriptionChange,
      handleFrameDescriptionZhChange,
      handlePackChange,
      handlePackZhChange,

    }



  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.topBox {
  display: flex;
  justify-content: space-between;

}

.imgBox {
  display: flex;
  align-items: center;
}

.imgBox img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 10px;
}

.avatar-container {
  display: flex;
  flex-wrap: wrap;
}

.avatar-box {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border: 1px dashed #d9d9d9;

}

.avatar-box:hover {
  border-color: #409EFF;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10%;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: white;
}

.delete-icon:hover {
  color: #409EFF;
}

.uploader-icon {
  font-size: 25px;
  color: #8c939d;
  text-align: center;
  margin-top: 50%;
  transform: translate(0%, -50%);
}
</style>
